import { customBaseUrl, httpGet, httpPut } from '../store/http';

export const getPendingSubscriptions = async (page = 0, size = 10, merchantId = null) => {
  let url = `${customBaseUrl.integUrl}/api/v1/portal/product-subscriptions/admin/requests?page=${page}&size=${size}`;
  if (merchantId) {
    url += `&merchantId=${merchantId}`;
  }
  return await httpGet(url);
};


export const reviewSubscription = async (requestId, approved, comment) => {
  return await httpPut(
    `${customBaseUrl.integUrl}/api/v1/portal/product-subscriptions/admin/requests/${requestId}`,
    { approved, comment }
  );
};
